import type { FaireProductEntity } from "../../entity_types/product";

export const p_kf82txecnk: FaireProductEntity = {
  token: "p_kf82txecnk",
  type: "product",
  name: "Darcy 18K Gold Non-Tarnish Oval Hoop Earring",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Flânerie by MAIQ",
  imageUrl:
    "https://cdn.faire.com/fastly/befa0c8b3dcbf15ac2c58755ca75cf0de00d28638a97fd0d83b2cb81a9b81948.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/38b099307e5ee37ab6ba74105c10de4a4888e79fa2fda91b4ac6ebdd8b4128c4.jpeg",
    "https://cdn.faire.com/fastly/4c2bba61d28c952fb11a87840f512ff3e4c9803af1efb401322c2ca883f49b27.jpeg",
    "https://cdn.faire.com/fastly/2e179d977d0d58918563a5e3acf392c7c437c950ba7f4f8ad174ac52a53954a4.jpeg",
    "https://cdn.faire.com/fastly/67e57be85f02efb81b9b37f76fab5d8b0bb426f0c4c3d2cb944d3b2aa44f3b8c.jpeg",
  ],
  priceDollars: 7.12,
  description:
    "18K Gold Non-Tarnish Oval Hoop Earring\n18K Gold Plating\nStainless Steel\nMeasurement (L x W inch): 1 x 0.8\n\n• Lead-free, Nickel-safe\n• Hypoallergenic\n• Water Resistant",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:38.667Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
